import Cookies from 'universal-cookie';
import { cleanLocalStorage } from './cleanLocalStorage';
import { LOGOUT_SYNC_KEY } from './constants';

// how long after useOIDCLogout sets LOGOUT_SYNC_KEY a deliberate logout redirect is considered "in progress" -
// bounded so a stale flag left over from a previous session (e.g. after navigating away to an external login app)
// can't permanently suppress a legitimate future unauthenticated-redirect
const LOGOUT_IN_PROGRESS_WINDOW_MS = 5000;

const readLogoutFlag = (): string | null => {
  try {
    return localStorage.getItem(LOGOUT_SYNC_KEY);
  } catch {
    return null;
  }
};

export const markLogoutInProgress = (): void => {
  try {
    localStorage.setItem(LOGOUT_SYNC_KEY, String(Date.now()));
  } catch {
    return;
  }
};

export const isLogoutInProgress = (): boolean => {
  const value = readLogoutFlag();

  if (!value) {
    return false;
  }

  const timestamp = Number(value);

  return !Number.isNaN(timestamp) && Date.now() - timestamp < LOGOUT_IN_PROGRESS_WINDOW_MS;
};

export const clearStaleSessionData = async (): Promise<void> => {
  try {
    cleanLocalStorage();

    const cookies = new Cookies();
    cookies.remove('openx3_access_token', { path: '/' });

    await Promise.all([
      indexedDB.deleteDatabase('dispatcher-cache-v2'),
      indexedDB.deleteDatabase('publisher-ui-cache-v2'),
      indexedDB.deleteDatabase('dsp-ui-cache-v2'),
      indexedDB.deleteDatabase('unity-cache-v2'),
    ]);
    // biome-ignore lint/suspicious/noConsole: Debug logging
    console.log('Stale session data cleared');
  } catch (error) {
    // biome-ignore lint/suspicious/noConsole: Debug logging
    console.warn('Error clearing stale session data:', error);
  }
};
